import { render } from "./CustomerBalances.vue?vue&type=template&id=7ce2bcb0&scoped=true"
import script from "./CustomerBalances.vue?vue&type=script&lang=js"
export * from "./CustomerBalances.vue?vue&type=script&lang=js"

import "./CustomerBalances.vue?vue&type=style&index=0&id=7ce2bcb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce2bcb0"]])

export default __exports__